import { initMainHeaderNav } from "./nav-sub-menus";
import { init as initScrolledBodyClass } from "./scrolled-body-class";
import { init as initBannerScrollBtns } from "./scroll-down-button";
import { init as initNavHamburger } from "./nav-hamburger";
import { init as initSearchPopout } from "./search-popout";
import { init as initCf7 } from "./cf7";
import { init as initLinkScroll } from "./link-scroll";
import { init as initLoadMore } from "./load-more";
import { init as initMailSignup } from "./mail-signup";
import { init as initBanner } from "./banner";
import { init as initImageSlider } from "./image-slider";
import { init as initCustomSelect } from "./custom-select";
import { initCustomFileInputs } from "./custom-file-input";
import { initCustomCheckboxes } from "./custom-checkbox";
//import { initDateInputs } from "./date-input";
import { initCf7FileInputs } from "./cf7-file-inputs";
import { initItemSliders } from "./item-slider";
import { initAllPopups, initAllPopupBtns } from "./popup";
import { initRiseUpFallDown } from "./rise-up-fall-down";
import { initFiniteEqualWidthSliders } from "./finite-equal-width-slider";
import { initInfiniteUnidirectionalAutoSliders } from "./infinite-unidirectional-auto-slider";
import { initSearchPopup } from "./search-popup";
import { initVideoPopup } from "./video-popup";
import { initShareLinks } from "./share-links";
import { initPostsPagination } from "./posts-pagination";
import { initLogoLinkMobileSrc } from "./logo-link-mobile-src";
import { initAltBgdImages } from "./alternative-background-images";
import { initTabbedContent } from "./tabbed-content";
import { initCollapsibleSections } from "./collapsible-sections";
import { initLazyThumbnails } from "./lazy-thumbnails";
import { initAccountPasswordCheck } from "./account";
import { initStretchText } from "./stretch-text";
import { initAddToCart } from "./add-to-cart";

declare const jQuery: any;
const $ = jQuery;

import "./jquery-easing";
//import "./lightbox-hacked";
import "./jquery-scrollto-hacked";
// @ts-ignore
import "./jquery-touchwipe-hacked";
import "./window-scroll-offset";
import "./file-upload-widget";
import "./drag";
import "./wheel";
import "./utils/css";

initScrolledBodyClass();
initAltBgdImages();
initLogoLinkMobileSrc();
initBanner();
initBannerScrollBtns();
initNavHamburger();
initRiseUpFallDown();
initMainHeaderNav();
initSearchPopout();
//initDatePickers();
//initDateInputs();
initCf7();
initCf7FileInputs();
initCustomFileInputs();
initLinkScroll();
initLoadMore();
initImageSlider();
initMailSignup();
initCustomSelect();
initCustomCheckboxes();
initItemSliders();
initAllPopups();
initAllPopupBtns();
initFiniteEqualWidthSliders();
initInfiniteUnidirectionalAutoSliders();
initSearchPopup();
initVideoPopup();
initShareLinks();
initPostsPagination();
initTabbedContent();
initCollapsibleSections();
initLazyThumbnails();
initAccountPasswordCheck();
initStretchText();
initAddToCart();
